import { Paper, Portal, Skeleton, styled } from "@mui/material";
import { StyledLinearProgress } from "components/loader/StyledLinearProgress";

interface Props {
  footerRef: HTMLDivElement;
  mapOverlayContainer: HTMLDivElement;
}

export function AddMeasurePageSkeleton(props: Props) {
  const { footerRef, mapOverlayContainer } = props;
  const numItems = new Array(3).fill(1);

  return (
    <StyledPaddedPaper elevation={0}>
      <Paper className="form-section" elevation={0}>
        <Skeleton className="header" width="60%" />
        {numItems.map((item, i) => (
          <Skeleton width={"40%"} height={50} key={i} />
        ))}
      </Paper>
      <Paper className="draw-section" elevation={0}>
        <Skeleton className="header" width="60%" />
        {numItems.map((item, i) => (
          <Skeleton key={i} />
        ))}
        <Skeleton width="30%" />
      </Paper>

      <Portal container={footerRef}>
        <StyledFooter className="footer" elevation={0}>
          <Skeleton width={100} height={40} />
          <Skeleton width={100} height={40} />
        </StyledFooter>
      </Portal>
      <Portal container={mapOverlayContainer}>
        <StyledLinearProgress />
      </Portal>
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(10)};

  .draw-section {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
  }

  .header {
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    max-width: 60%;
  }

  .form-section {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: ${({ theme }) => theme.spacing(2)};

    .MuiSkeleton-root {
      flex-grow: 1;
    }
  }
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
`;

const StyledFooter = styled(Paper)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
`;
